import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { CreateDocumentCategoryActions } from 'store/ducks/settings/document-category';

export function* createDocumentCategoryRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/document-category`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateDocumentCategoryActions.success(data));
    notify('success', 'Categoria de documento cadastrado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(CreateDocumentCategoryActions.failure(errorMessage));
  }
}
